import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { Taxon } from '../js/ebird/taxonomy';

import { store } from './store';

import App from './ui/app';
import { Database, initDatabase } from 'web/db';
import appSlice from 'web/app_slice';
import { DatabaseContext } from 'web/db_context';

import './base.css';

// TODO: Make this an external file for esbuild
declare global { interface Window { taxonomy2024: Taxon[] } }

// TODO: Can we do top-level await?
initDatabase(window.taxonomy2024).then(async (database: Database) => {
  const all = await database.allObservations();
  store.dispatch(appSlice.actions.initObservations(all));

  // TODO: Could technically import a file with 0 observations
  const root = createRoot(document.getElementById('root')!);
  root.render(
    <StrictMode>
      <Provider store={ store } >
        <DatabaseContext.Provider value={ database }>
          <App />
        </DatabaseContext.Provider>
      </Provider>
    </StrictMode>
  );
});
